import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo, useState } from "react";
import { withNamespaces } from "react-i18next";
import { toast } from "react-toastify";
import TableFilter from "src/components/TableFilter";
import DateUtils from "src/services/utils/DateUtils";
import {
    HistoryLogActions
} from "src/modules/3rd-party-management/constants";
import CommonService from "src/modules/3rd-party-management/apis/common/CommonService";

const sectionKey = 'kybScreening';

const FilteringComponent = ({
    t,
    onChange
}) => {
    const [tableFilters, setTableFilters] = useState({
        fromDate: null,
        toDate: null,
        user: null,
        actions: []
    });

    const dateUtils = new DateUtils();

    const usersQuery = useQuery({
        queryKey: ['3rd-party-management-supplier-users-list'],
        queryFn: async () => {
            const service = CommonService.getInstance();

            return await service.fetchUsers();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t('An error occurred while fetching users list.'), {
                type: 'error'
            });
        },
    });


    const avActions = useMemo(() => {
        return Object.keys(HistoryLogActions[sectionKey]).map((actionKey) => {
            return {
                id: actionKey,
                title: HistoryLogActions[sectionKey][actionKey]
            }
        })
    }, []);

    const tableFilterTabs = useMemo(() => {
        return [
            {
                type: 'date',
                name: 'filter-date',
                title: 'Date',
                icon: <i className="ri-calendar-event-line" />,
                defaultValue: {
                    from: tableFilters['createdAt[from]'],
                    to: tableFilters['createdAt[to]']
                }
            },
            {
                type: 'radio_list',
                name: 'user',
                title: 'User',
                icon: <i className="ri-user-line" />,
                isLoading: usersQuery.isFetching || usersQuery.isLoading,
                defaultValue: tableFilters?.user,
                data: usersQuery.data || [],
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return `${item.first_name} ${item.last_name}`
                }
            },
            {
                type: 'check_list',
                name: 'actions',
                title: 'Actions',
                icon: <i className="ri-run-line" />,
                defaultValue: tableFilters?.actions,
                data: avActions,
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return item.title
                }
            }
        ]
    }, [
        tableFilters,
        usersQuery,
        avActions
    ]);

    const onTableFilterOkButtonClicked = (filters) => {
        if (filters) {
            const result = {}

            if ('filter-date' in filters) {
                result['fromDate'] = dateUtils.convertDateToDate(
                    new Date(filters['filter-date']?.from),
                    'YYYY-MM-DD 00:00:00'
                )

                result['toDate'] = dateUtils.convertDateToDate(
                    new Date(filters['filter-date']?.to),
                    'YYYY-MM-DD 23:59:59'
                )
            }

            if ('user' in filters) {
                result.user = filters.user !== 'all' ? filters.user : undefined
            }

            result.actions = filters.actions.length > 0 ? filters.actions : undefined

            setTableFilters({
                ...tableFilters,
                ...result
            })
        } else {
            setTableFilters({
                fromDate: null,
                toDate: null,
                user: null,
                actions: []
            })
        }
    }

    useEffect(() => {
        onChange && onChange(tableFilters)
    }, [tableFilters]);

    return (
        <TableFilter
            className="me-2"
            defaultActiveTab='filter-date'
            tabs={tableFilterTabs}
            onOkButtonClicked={
                onTableFilterOkButtonClicked
            }
        />
    )
}

export default withNamespaces()(FilteringComponent);